import {workplaceTypes} from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { BaggageTapeList } from "./ConveyerFlightsPage";
import {HeaderMenuBlock} from "../Block/HeaderMenuBlock/HeaderMenuBlock";
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

export var SelectConveyerPage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (localStorage.getItem('baggageTapeId')) {
            m.route('/conveyer/flight');
            return;
        }
        if (user.get('state.workplace') !== workplaceTypes.conveyer) {
            m.route('/');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = BaggageTapeList.init();

        return {
            data: data,
            setBaggageTape: function (e) {

                e.preventDefault();
                self.errmsg = '';

                var baggageTapeId = e.target.baggageTape.value;
                var baggageTape = BaggageTapeList.list[baggageTapeId];

                var data = {
                    id: parseInt(baggageTapeId),
                    name: baggageTape.name
                };

                if (!data.id) {
                    self.errmsg = (m(".alert.alert-danger", 'Лента не выбрана'));
                    return;
                }

                m.request({
                    method: 'POST',
                    url: '/api/baggage-tape',
                    data: data
                }).then(function (response) {
                    server.setOnline();
                    loader.hide();
                    storage.config = response.config;

                    localStorage.setItem('baggageTapeId', data.id);
                    localStorage.setItem('baggageTapeName', data.name);

                    m.route('/');
                }, function (response) {
                    if (response && response.message) {
                        self.errmsg = (m(".alert.alert-danger", response.message));
                    } else {
                        server.setOffline();
                    }
                    loader.hide();
                });
            },
            topMenu: [
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' },
            ]
        };
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: {},
                menu: ctrl.topMenu
            }),
            ctrl.errmsg,
            m(".container", [
                m("form", {
                    onsubmit: ctrl.setBaggageTape.bind(ctrl)
                }, [
                    m(".form-group", [
                        m("select.form-control.input-lg[name='baggageTape']", [
                            m("option", {value: null}, 'Выберите ленту выдачи багажа'),
                            BaggageTapeList.list.map(function(baggageTape, id) {
                                return m("option", {
                                    value: id
                                }, baggageTape.name);
                            })
                        ])
                    ]),
                    m("button.btn.btn-success.btn-block.btn-lg[type='submit']", "Выбрать")
                ])
            ])
        ];
    }
};
